import { productAdapter } from "../adapters/product-adapter";
import { productResource } from "../resources/product-resource";
import { ClientProduct } from "../types/product";

export const ProductRepository = {
  async fetchProduct(id: number): Promise<ClientProduct> {
    const apiProduct = await productResource.getProduct(id);
    return productAdapter.toClient(apiProduct);
  },
};
